














import { defineComponent } from '@nuxtjs/composition-api'
import ImageDatasheetPage from './ImageDatasheetPage.vue'
import { Figure, MappedProduct } from '~/types/product/productTypes'
import { pageContentSize, pixelsPerInch } from '~/common/constants/datasheet'
import { useCloudflareStore } from '~/store'

export default defineComponent({
  components: {
    ImageDatasheetPage,
  },
  props: {
    product: {
      type: Object as () => MappedProduct,
      required: true,
    },
    size: {
      type: String as () => 'a4' | 'letter',
      required: true,
    },
  },
  setup(props) {
    const imageMinHeight = 190
    const imageWidth = 260

    const contentHeightInInches = pageContentSize[props.size].height - 2.5 // decrement by 2.5 inches so there is some space left for header and footer
    const imageSectionHeight = contentHeightInInches * pixelsPerInch

    const cloudflareStore = useCloudflareStore()

    // split images into pages based on their height
    const pages: Figure[][] = [[]]
    let currentPageHeight = 0
    for (const image of props.product.attributes.images) {
      let imageHeight = imageWidth * (Number(image.imageheight) / Number(image.imagewidth)) // The heigh of an image when rendered on page (in px)
      imageHeight = Math.max(imageHeight, imageMinHeight)
      currentPageHeight += imageHeight
      const cImage = { ...image, cloudflare: cloudflareStore.images[image['dam-media-id']] }
      if (currentPageHeight <= imageSectionHeight) {
        pages.at(-1)!.push(cImage)
      } else {
        pages.push([cImage])
        currentPageHeight = imageHeight
      }
    }

    return {
      pages,
      imageWidth,
      imageMinHeight,
      pageHeight: (pageContentSize[props.size].height * pixelsPerInch) / 16,
    }
  },
})
